import { render, staticRenderFns } from "./CameraEdit.vue?vue&type=template&id=5e3631d6&"
import script from "./CameraEdit.vue?vue&type=script&lang=js&"
export * from "./CameraEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports